import { Banner, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { CancellationPolicyWithProfiles } from '@mews-commander/data-access';
import { ActorProfilesSection } from '../../../components';
import { CancellationPolicyDetail } from './CancellationPolicyDetail';

interface Props
    extends Pick<
        CancellationPolicyWithProfiles,
        | 'name'
        | 'bookablePeriod'
        | 'absoluteFee'
        | 'absoluteFeeCurrencyCode'
        | 'relativeFee'
        | 'applicabilityType'
        | 'applicabilityOffset'
        | 'feeExtent'
        | 'feeMaximumTimeUnits'
        | 'createdUtc'
        | 'creatorProfileName'
        | 'updatedUtc'
        | 'updaterProfileName'
        | 'isPortfolioManaged'
    > {
    policyKey?: string | null;
}

export const CancellationPolicyDetailsTabContent = ({
    createdUtc,
    creatorProfileName,
    updatedUtc,
    updaterProfileName,
    isPortfolioManaged,
    policyKey,
    ...other
}: Props) => (
    <Stack spacing="400" vertical>
        {isPortfolioManaged ? (
            <Banner
                primaryText={lt('CancellationPolicyLinkedBannerTitle')}
                secondaryText={lt('CancellationPolicyLinkedBannerDescription')}
                variant="info"
            />
        ) : null}
        <CancellationPolicyDetail {...other} policyKey={policyKey} />
        <ActorProfilesSection
            createdUtc={createdUtc}
            creatorProfile={{ name: creatorProfileName }}
            updatedUtc={updatedUtc}
            updaterProfile={{ name: updaterProfileName }}
        />
    </Stack>
);
